export type ExampleReport = "role" | "candidate" | "match";

/** Legacy identifiers remain an implementation detail of the existing report renderer. */
export function exampleReportParam(report: string): ExampleReport {
  if (report === "brief" || report === "role") return "role";
  if (report === "dossier" || report === "candidate") return "candidate";
  return "match";
}

export function exampleReportId(report: string | null): "brief" | "dossier" | "match" {
  if (report === "role" || report === "brief") return "brief";
  if (report === "candidate" || report === "dossier") return "dossier";
  return "match";
}
